import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PropertyIdentifier, PropertyInformation } from '@store/search-board/search-board.model';

@Injectable({
  providedIn: 'root'
})
export class SavedPropertiesService {

  constructor(private readonly httpClient: HttpClient) { }

  public getSavedProperties(): Observable<Array<PropertyInformation>> {
    return this.httpClient.get<Array<PropertyInformation>>('/api/get-favorites');
  }

  public updateSavedProperties(propertyIdentifiers: Array<PropertyIdentifier>): Observable<void> {
    return this.httpClient.post<void>('/api/favorite-properties', {propertyIdentifiers});
  }
}
